import {
    LOAD_EXCESS_EXPENSES,
    LOAD_EXCESS_EXPENSES_DETAIL,
    CREATE_EXCESS_EXPENSES,
    UPDATE_EXCESS_EXPENSES,
    EXPORT_EXCESS_EXPENSES,
    REMOVE_LISTS,
} from './actions'

const initialState = {
    lists: [],
    listDetail: null,
    total: 1,
    loading: false,
    draw: -1,
    check: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_LISTS:
            return initialState
      
        case LOAD_EXCESS_EXPENSES.REQUEST:
            const { loading } = action.payload.data
            return {
              ...state,
              loading: loading,
            }
            
        case LOAD_EXCESS_EXPENSES.SUCCESS:
                const { page } = action.payload
                for (let i = 0; i < action.payload.lists.data.length; i++) {
                  action.payload.lists.data[i].rowNumber = i + 1
                  if (page > 1)
                    action.payload.lists.data[i].rowNumber =
                      action.payload.lists.data[i].rowNumber + (page - 1) * 10
                }
                return {
                  ...state,
                  lists: action.payload.lists.data,
                  total:
                    action.payload.lists.total - 1 <= 0
                      ? 1
                      : action.payload.lists.total <= 0
                      ? 1
                      : action.payload.lists.total,
                  loading: false,
                  draw: Math.floor(Math.random() * 999 + 1),
                }
        
        case LOAD_EXCESS_EXPENSES_DETAIL.REQUEST:
            return {
                ...state,
                loading: true,
                check: true,
            }

        case LOAD_EXCESS_EXPENSES_DETAIL.SUCCESS:
            return {
                ...state,
                loading: false,
                listDetail: action.payload.listDetail.data,
                check: false,
            }

        case CREATE_EXCESS_EXPENSES.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case CREATE_EXCESS_EXPENSES.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case UPDATE_EXCESS_EXPENSES.REQUEST:
            return {
                ...state,
                loading: true,
            }

        case UPDATE_EXCESS_EXPENSES.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case EXPORT_EXCESS_EXPENSES.REQUEST: 
            return {
                ...state,
                loading: true,
            }

        case EXPORT_EXCESS_EXPENSES.SUCCESS: 
            return {
                ...state,
                loading: false,
            }
            
        default:
            return state
    }
}